<template>
  <el-table
    border
    ref="multipleTable"
    :data="tableData"
    tooltip-effect="dark"
    @selection-change="selectionChange"
    :header-cell-style="{ background: '#f4f5f9', color: '#000' }"
    :row-key="getRowkey"
    :expand-row-keys="expandRowKeys"
    @sort-change="sortChange"
    :default-sort="headConfig.defaultSort ? headConfig.defaultSort : {}"
  >
    <el-table-column
      align="center"
      type="selection"
      width="55"
      v-if="headConfig.select"
      :selectable="selectable"
    ></el-table-column>
    <el-table-column
      align="center"
      :label="config.label"
      :prop="config.prop"
      :width="config.width"
      :type="config.type"
      :sortable="config.sortable"
      :key="config.prop"
      v-for="config in headConfig.list"
      :show-overflow-tooltip="config.tip"
    >
      <template slot="header" v-if="config.type === 'expand'">
        <div @click="expand">
          <span>详情</span
          ><i
            :class="
              expandRowKeys.length
                ? 'el-icon-caret-bottom'
                : 'el-icon-caret-right'
            "
          ></i>
        </div>
      </template>
      <template slot-scope="scope">
        <div v-if="config.operation">
          <div
            v-for="btnConfig in config.operation"
            :key="btnConfig.type"
            style="display: inline-block"
          >
            <el-popconfirm
              :title="btnConfig.confirm"
              class="btn"
              v-if="
                btnConfig.confirm &&
                (btnConfig.show ? btnConfig.show(scope.row) : true)
              "
              @confirm="operation(btnConfig.listeners, scope.row)"
            >
              <el-button
                size="mini"
                :type="btnConfig.style"
                :disabled="
                  btnConfig.disabled ? btnConfig.disabled(scope.row) : false
                "
                slot="reference"
                >{{ btnConfig.label }}</el-button
              >
            </el-popconfirm>
            <el-button
              v-if="
                !btnConfig.confirm &&
                (btnConfig.show ? btnConfig.show(scope.row) : true)
              "
              size="mini"
              :type="btnConfig.style"
              class="btn"
              :disabled="
                btnConfig.disabled ? btnConfig.disabled(scope.row) : false
              "
              @click="operation(btnConfig.listeners, scope.row)"
            >
              {{ btnConfig.label }}</el-button
            >
          </div>
        </div>
        <dl class="table-expand" v-else-if="config.type === 'expand'">
          <dt v-if="getImg(scope.row)">
            <ImageBox :src="getImg(scope.row)" :list="[getImg(scope.row)]" />
          </dt>
          <dd>
            <h3>{{ scope.row.content }}</h3>
            <div class="dis-flex">
              <span>发布链接：</span>
              <p>{{ scope.row.link }}</p>
            </div>
            <div class="dis-flex">
              <span>留言信息：</span>
              <p>{{ scope.row.leaveMessage }}</p>
            </div>
          </dd>
        </dl>
        <span v-else-if="config.prop === 'status'">{{
          status[scope.row[config.prop]]
        }}</span>
        <span v-else-if="config.prop === 'sendType'">{{
          sendType[scope.row[config.prop]]
        }}</span>
        <span v-else-if="config.prop === 'roleType'">{{
          roleType[scope.row[config.prop]]
        }}</span>
        <span v-else-if="config.prop === 'userStatus'">{{
          userStatus[scope.row[config.prop]]
        }}</span>
        <span v-else-if="config.prop === 'postType'">{{
          postType[scope.row[config.prop]]
        }}</span>
        <div v-else-if="config.prop === 'content'" class="text-left">
          <div class="ellipsis" v-if="scope.row[config.prop]">
            文本：<span>{{ scope.row[config.prop] }}</span>
          </div>
          <div class="ellipsis" v-if="scope.row.link">
            链接：<span>{{ scope.row.link }}</span>
          </div>
          <div class="ellipsis" v-if="scope.row.imagePath">
            图片：<span>{{ scope.row.imagePath }}</span>
          </div>
        </div>
        <div v-else-if="config.prop === 'pageName'">
          <el-link
            v-if="scope.row[config.prop].split(',').length == 1"
            type="primary"
            :href="`https://www.facebook.com/${scope.row.pageId}`"
            target="_blank"
            >{{ scope.row[config.prop] }}</el-link
          >
          <el-dropdown v-else>
            <span class="el-dropdown-link">
              查看专页<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(page, index) in scope.row[config.prop].split(',')"
                :key="page"
              >
                <a
                  :href="`https://www.facebook.com/${
                    scope.row.pageId.split(',')[index]
                  }`"
                  target="_blank"
                >
                  {{ page }}
                </a>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div v-else-if="config.prop === 'message'">
          <span>{{ scope.row[config.prop] }}</span>
          <div v-if="scope.row.imageUrl">
            <ImageBox :src="scope.row.imageUrl" :list="[scope.row.imageUrl]" />
          </div>
        </div>
        <div v-else-if="config.prop === 'date'">
          <span>{{
            formatTime(new Date(scope.row[config.prop]), "yyyy-MM-dd")
          }}</span>
        </div>
        <div class="ellipsis" v-else>
          <span>{{ scope.row[config.prop] || "-" }}</span>
        </div>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import ImageBox from "@/components/Image";
import { formatTime } from "@/utils/time.js";
export default {
  props: {
    headConfig: {
      type: Object,
      default: () => {},
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    selectable: {
      type: Function,
      default: () => function () {},
    },
  },
  data() {
    return {
      formatTime,
      status: {
        1: "已发布",
        2: "已删除",
        3: "待发布",
      },
      sendType: {
        1: "链接",
        2: "图片",
        3: "文本",
      },
      roleType: {
        1: "管理员",
        2: "普通用户",
      },
      userStatus: {
        0: "正常",
        1: "停用",
      },
      postType: {
        1: "帖文",
        2: "留言",
      },
      expandRowKeys: [],
    };
  },
  components: {
    ImageBox,
  },
  methods: {
    getRowkey(row) {
      return row[this.headConfig.key];
    },
    getImg(row) {
      const { imagePath, backGroundId } = row;
      if (imagePath) {
        return imagePath;
      } else if (backGroundId) {
        return require(`@/assets/background/${backGroundId}.jpg`);
      }
      return false;
    },
    operation(event, row) {
      this.$listeners[event](row);
    },
    selectionChange(val) {
      this.$emit("select-change", val);
    },
    expand() {
      if (this.expandRowKeys.length) {
        this.expandRowKeys = [];
      } else {
        this.expandRowKeys = this.tableData.map((item) => {
          return item[this.headConfig.key];
        });
      }
    },
    sortChange(data) {
      this.$emit("sort-change", data);
    },
    resetSort() {
      this.$refs.multipleTable.clearSort();
    },
  },
};
</script>
<style lang="less" scoped>
@import "~@/style/mixin.less";
.el-image {
  width: 100px;
  height: 100px;
}

.el-table .el-table__cell {
  padding: 8px;
}

.el-table__header .el-table__cell {
  padding: 0;
}

.table-expand {
  background: #f8f9fb;
  padding: 15px 20px;
  display: flex;

  dt .el-image {
    border: 1px solid #ebeef5;
    margin-right: 20px;
  }

  dd {
    font-size: 12px;
    max-width: 600px;

    h3 {
      font-size: 14px;
      margin-bottom: 10px;
    }

    span {
      display: block;
      white-space: nowrap;
    }

    .dis-flex {
      margin-top: 5px;
      align-items: flex-start;
    }
  }
}

.btn {
  margin: 0 5px;
}

.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}

.el-icon-arrow-down {
  font-size: 12px;
}

::v-deep .el-table__body-wrapper {
  .self-scrollbar;
}
</style>
